cb.define([], function () {
  var AA_aa_reason_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      var self = this;
      viewmodel.get("iOrder").setState("min", 0);
      viewmodel.get("stopstatus").setValue(0);
    },
  }

  try {
    module.exports = AA_aa_reason_VM_Extend;
  } catch (error) {

  }

  return AA_aa_reason_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_reason_VM.Extend.js